import { setActiveTab } from 'utils/actions/active-tab/active-tab.actions';
import { fetchMessage, clearSelectedMessage } from 'message/actions/message-details.actions';
import { deleteMessage } from 'message/actions/inbox.actions';
import { checkAccess } from 'app/actions/app.actions';
import tabs from '../messages-tab/tabs';
import template from './message-details.html';

const mapStateToThis = ({ messages }) => {
  const { INBOX } = tabs;
  const { selectedMessage } = messages;

  return {
    INBOX,
    selectedMessage,
  };
};
const mapDispatchToThis = {
  fetchMessage,
  clearSelectedMessage,
  deleteMessage,
  setActiveTab,
  checkAccess,
};

// eslint-disable-next-line no-undef
@Inject('$sce', '$state', '$ngRedux', 'Notifications', 'messageDefinitionService')
class MessageDetailsController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  $onInit() {
    this.fetchMessage(this.userMessageId);
  }

  $onDestroy() {
    this.clearSelectedMessage();
    this.unsubscribe();
  }

  async onDeleteMessage() {
    await this.deleteMessage(this.userMessageId);
    this.Notifications.alertSuccess(this.messageDefinitionService.get('MSG_DELETE', 'desc'));
    this.goToInboxMessages();
  }

  goToInboxMessages() {
    this.setActiveTab(this.INBOX, 'activeTab');
    this.$state.go('message.list');
  }

  canReply() {
    return this.selectedMessage && this.selectedMessage.allowReply;
  }

  replyMessage() {
    this.Notifications.showComplexDialog({
      backdrop: 'static',
      component: 'replyMessageDialog',
    });
  }
}

export default class MessageDetailsComponent {
  constructor() {
    this.controller = MessageDetailsController;
    this.template = template;
    this.bindings = {
      userMessageId: '<',
    };
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/message/components/message-details/message-details-component.js